import { useMissionsTranslation } from '../../../../ui/hooks';
import { formatPhoneNumber } from '@juvare/common-phone-number';
import { Typography } from '@mui/material';
import React from 'react';
export function useVolunteerShiftParticipantsTableColumns() {
    const { t } = useMissionsTranslation();
    return [
        {
            headerLabel: t('shifts.rosterTable.positionName'),
            cellFunction: (row) => {
                return (React.createElement(Typography, { variant: 'body2', color: 'textSecondary' }, row.columns.positionName));
            },
        },
        {
            headerLabel: t('shifts.rosterTable.participantFullName'),
            cellFunction: (row) => (React.createElement(Typography, { variant: 'body2', color: 'textSecondary' }, row.columns.participantFullName)),
            tableCellSx: { maxWidth: 200 },
        },
        {
            headerLabel: t('shifts.rosterTable.occupations'),
            cellFunction: (row) => {
                return (React.createElement(Typography, { variant: 'body2', color: 'textSecondary' }, row.columns.occupations));
            },
            tableCellSx: { maxWidth: 149 },
        },
        {
            headerLabel: t('shifts.rosterTable.participantEmail'),
            cellFunction: (row) => {
                const email = row.columns.showContactInfo ? row.columns.participantEmail : t('shifts.rosterTable.emailIsHidden');
                return (React.createElement(Typography, { variant: 'body2', color: 'textSecondary' }, email));
            },
        },
        {
            headerLabel: t('shifts.rosterTable.participantContactInfo'),
            cellFunction: (row) => {
                const phoneNumber = row.columns.participantContactInfo
                    ? formatPhoneNumber(row.columns.participantContactInfo)
                    : row.columns.participantContactInfo;
                const contactInfo = row.columns.showContactInfo ? phoneNumber : t('shifts.rosterTable.contactIsHidden');
                return (React.createElement(Typography, { variant: 'body2', color: 'textSecondary' }, contactInfo));
            },
        },
    ];
}
